<div class="sketches">

  <div class="txt" (click)="click()">
    Drawings {{(sketch_number)}} of {{sketches.length}} <span *ngIf="sketch_number">at {{sketch_time| number:'1.2-2' }} </span>
  </div>
  <div class="arrows">
    <img class="prev" src="assets/images/expand_l.svg" kzLib (click)="prev()" [ngClass]="{disabled:sketch_number<2}">
    <img class="next" src="assets/images/expand_l.svg" kzLib (click)="next()" [ngClass]="{disabled:sketch_number==sketches.length}">
  </div>

  <div *ngIf="act!='intro'" class="at fl h20">
    at {{sketch_time | number:'1.2-2'}}
  </div>
  <img *ngIf="bShowRecUI && sketch_number>0" class="delete" src="assets/images/delete.svg" (click)="delSketch() " alt="">
</div>
